import { render } from "./generalAccountStatement.vue?vue&type=template&id=322b9fd3&scoped=true"
import script from "./generalAccountStatement.vue?vue&type=script&lang=js"
export * from "./generalAccountStatement.vue?vue&type=script&lang=js"

import "./generalAccountStatement.vue?vue&type=style&index=0&id=322b9fd3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322b9fd3"]])

export default __exports__